import { FormProps, ModalProps, useSelect, Spin, Modal, Button, Form, Row, Col, Checkbox, Select, Input } from '@pankod/refine-antd'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import type { RangePickerProps } from 'antd/es/date-picker'
import { DatePicker } from 'antd'
import React, { useState } from 'react'
import { useList, useUpdate } from '@pankod/refine-core'

dayjs.extend(customParseFormat)

interface TaskEditProps {
  modalProps: any
  formProps: any
  users: any
  close: () => void
  managerId: string
  loading: boolean
}

const SupportTaskEdit: React.FC<TaskEditProps> = ({ modalProps, formProps, users, close, managerId, loading }) => {
  const task_id = formProps?.initialValues?.id
  const [taskspermissions, setTaskPermissions] = useState<any>(null)
  const { mutateAsync } = useUpdate()
  const { isLoading, data: permission } = useList({
    resource: 'permissions',
    config: {
      filters: [
        {
          field: 'task_id',
          operator: 'eq',
          value: task_id,
        },
      ],
      hasPagination: false,
    },
    metaData: {
      fields: [
        'id',
        'can_read',
        'can_create',
        'can_delete',
        'can_update',
        'module_id',
        {
          module: ['id', 'label', 'value'],
        },
      ],
    },
    queryOptions: {
      enabled: !!task_id,
      onSuccess(data) {
        // console.log(data?.data, 'permission')
        formProps?.form?.setFieldsValue({
          module_id: data?.data?.map((mod: any) => mod?.module_id),
        })
        setTaskPermissions(data?.data)
      },
    },
  })
  console.log(permission?.data, 'permission')
  // const permission_id: any = permission?.data?.
  const { selectProps: moduleProps } = useSelect({
    resource: 'modules',
    optionLabel: 'label',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'label'],
    },
    onSearch: value => [
      {
        field: 'label',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
    queryOptions: {
      enabled: modalProps?.visible === true,
    },
  })
  const disabledDate: RangePickerProps['disabledDate'] = (current: any) => {
    // return current && current > dayjs().endOf('day')
    return current && current < dayjs().startOf('day')
  }
  const onCancel = async () => {
    close()
    // formProps?.form?.resetFields()
  }
  const onCheckRead = (event: any, idx: number) => {
    // formProps?.form?.setFieldsValue({
    //                     can_read: e?.target?.checked,
    //                   })
    //                 }
    const arr = [...taskspermissions]
    const index = arr.findIndex((mod: any, index: number) => index === idx)
    const copyOfIndexObject = { ...arr[index] }
    copyOfIndexObject.can_read = event?.target?.checked
    arr[index] = copyOfIndexObject
    setTaskPermissions(arr)
  }
  const onCheckCreate = (event: any, idx: number) => {
    // formProps?.form?.setFieldsValue({
    //                     can_read: e?.target?.checked,
    //                   })
    //                 }
    const arr = [...taskspermissions]
    const index = arr.findIndex((mod: any, index: number) => index === idx)
    const copyOfIndexObject = { ...arr[index] }
    copyOfIndexObject.can_create = event?.target?.checked
    arr[index] = copyOfIndexObject
    // const specifickey = taskspermissions?.fin
    setTaskPermissions(arr)
    // console.log(copyOfIndexObject, 'index')
  }
  const onCheckUpd = (event: any, idx: number) => {
    // formProps?.form?.setFieldsValue({
    //                     can_read: e?.target?.checked,
    //                   })
    //                 }
    const arr = [...taskspermissions]
    const index = arr.findIndex((mod: any, index: number) => index === idx)
    const copyOfIndexObject = { ...arr[index] }
    copyOfIndexObject.can_update = event?.target?.checked
    arr[index] = copyOfIndexObject
    setTaskPermissions(arr)
  }
  const onCheckDel = (event: any, idx: number) => {
    // formProps?.form?.setFieldsValue({
    //                     can_read: e?.target?.checked,
    //                   })
    //                 }
    const arr = [...taskspermissions]
    const index = arr.findIndex((mod: any, index: number) => index === idx)
    const copyOfIndexObject = { ...arr[index] }
    copyOfIndexObject.can_delete = event?.target?.checked
    arr[index] = copyOfIndexObject
    setTaskPermissions(arr)
  }
  console.log(taskspermissions, 'taskspermissions')
  const onFinish = async (data: any) => {
    const { assignee_id, module_id, start_date, end_date, name, description, ...rest } = data
    const task_object = {
      name,
      assignee_id,
      // module_id,
      description,
      start_date: dayjs(start_date).format('YYYY-MM-DD'),
      end_date: dayjs(end_date).format('YYYY-MM-DD'),
      created_by: managerId,
    }
    console.log('onfinish_permission', taskspermissions)
    if (formProps?.onFinish) {
      for (let i = 0; i < taskspermissions?.length; i++) {
        const permission_object = {
          id: taskspermissions?.[i]?.id,
          can_create: taskspermissions?.[i]?.can_create,
          can_delete: taskspermissions?.[i]?.can_delete,
          can_read: taskspermissions?.[i]?.can_read,
          can_update: taskspermissions?.[i]?.can_update,
          support_id: assignee_id,
          module_id: taskspermissions?.[i]?.module_id,
        }
        const { id, ...rest } = permission_object
        mutateAsync(
          {
            resource: 'permissions',
            id: permission_object?.id,
            values: {
              ...rest,
            },
            successNotification: false,
          },
          {
            onSuccess: data => {
              formProps?.onFinish({
                ...task_object,
              })
            },
          }
        )
      }
    }
  }
  const onSelectChange = (value: any, option: any) => {
    // store the values in setstate from props
    setTaskPermissions([...option])
  }
  // console.log(formProps?.initialValues?.permissions?.[0], 'formProps')

  return (
    <Modal
      {...modalProps}
      title="Edit Task"
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      footer={[
        <Button onClick={onCancel}>Cancel</Button>,
        <Button
          type="primary"
          // onClick={formProps?.form?.submit}
          {...modalProps.okButtonProps}
        >
          Submit
        </Button>,
      ]}
    >
      {/* {loading ? (
        <Spin />
      ) : ( */}
      <Form {...formProps} layout="vertical" onFinish={onFinish}>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={6}>
            <Form.Item
              label="Task Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Field Required !',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col lg={6} xs={24}>
            <Form.Item
              label="Start Date"
              name="start_date"
              rules={[{ required: true, message: 'Field Required !' }]}
              getValueProps={value => ({
                value: value ? dayjs(value) : '',
              })}
            >
              <DatePicker style={{ width: '100%' }} format={'DD-MM-YYYY'} disabledDate={disabledDate} />
            </Form.Item>
          </Col>
          <Col lg={6} xs={24}>
            <Form.Item
              label="End Date"
              name="end_date"
              rules={[{ required: true, message: 'Field Required !' }]}
              getValueProps={value => ({
                value: value ? dayjs(value) : '',
              })}
            >
              <DatePicker style={{ width: '100%' }} format={'DD-MM-YYYY'} disabledDate={disabledDate} />
            </Form.Item>
          </Col>
          <Col lg={6} xs={24}>
            <Form.Item label="Assignee" name="assignee_id">
              <Select allowClear onChange={undefined} options={users} />
            </Form.Item>
          </Col>
          <Col lg={24} xs={24}>
            <Form.Item
              label="Modules"
              name="module_id"
              rules={[
                {
                  required: true,
                  message: 'Field Required !',
                },
              ]}
            >
              <Select
                {...moduleProps}
                value={taskspermissions?.map((mod: any) => mod?.module_id)}
                allowClear
                mode="multiple"
                onChange={onSelectChange}
              />
            </Form.Item>
          </Col>
          <Col lg={24} xs={24}>
            <Form.Item
              label="Task Description"
              name="description"
              rules={[
                {
                  required: true,
                  message: 'Field Required !',
                },
              ]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
        {/* iterate modules through with permissions */}
        {taskspermissions?.length > 0 && (
          <>
            <h1>Module Permissions</h1>
            {taskspermissions?.map((module: any, index: number) => (
              <Row gutter={16} key={index}>
                <Col lg={24}>
                  <h1>{module?.module?.label}</h1>
                </Col>
                <Col lg={4}>
                  <Form.Item name="can_read">
                    <Checkbox
                      // onChange={(e: any) =>
                      //   formProps?.form?.setFieldsValue({
                      //     can_read: e?.target?.checked,
                      //   })
                      // }
                      defaultChecked={module?.can_read}
                      onChange={(e: any) => onCheckRead(e, index)}
                    >
                      View
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col lg={4}>
                  <Form.Item name="can_create">
                    <Checkbox
                      // onChange={(e: any) =>
                      //   formProps?.form?.setFieldsValue({
                      //     can_create: e?.target?.checked,
                      //   })
                      // }
                      onChange={(e: any) => onCheckCreate(e, index)}
                      defaultChecked={module?.can_create}
                    >
                      Create
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col lg={4}>
                  <Form.Item name="can_update">
                    <Checkbox
                      // onChange={(e: any) =>
                      //   formProps?.form?.setFieldsValue({
                      //     can_update: e?.target?.checked,
                      //   })
                      // }
                      onChange={(e: any) => onCheckUpd(e, index)}
                      defaultChecked={module?.can_update}
                    >
                      Edit
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col lg={4}>
                  <Form.Item name="can_delete">
                    <Checkbox
                      // onChange={(e: any) =>
                      //   formProps?.form?.setFieldsValue({
                      //     can_delete: e?.target?.checked,
                      //   })
                      // }
                      defaultChecked={module?.can_delete}
                      onChange={(e: any) => onCheckDel(e, index)}
                    >
                      Delete
                    </Checkbox>
                  </Form.Item>
                </Col>
              </Row>
            ))}
          </>
        )}
        {/*  */}
      </Form>
    </Modal>
  )
}

export default SupportTaskEdit
